import { createContext } from 'react'

const GridContext = createContext(12)

export default GridContext
